import { createFileRoute, redirect } from "@tanstack/react-router";
import { PublicPortalPage } from "~/features/dashboard";
import { createPageHead } from "~/shared/lib/page-head";
import { t } from "@lingui/core/macro";
import { getBrand } from "~/tenant";

export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    if (context.user) {
      throw redirect({ to: "/dashboard" });
    }
  },
  head: () => createPageHead(t`Home`, getBrand().description),
  component: HomePage,
});

function HomePage() {
  return <PublicPortalPage />;
}
